import { useState } from "react";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import ChatCache from "../../../../utils/ChatCache";
import Analytics from "../../../../utils/Analytics";
import localization from "../../../../assets/localization";

const chatCache = new ChatCache();

interface MessageFeedbackProps {
  message: any;
  index: number;
  assistantId: string;
  language: string;
}

// Guest feedback on a single assistant reply. The vote ships as a
// message_feedback analytics event carrying an excerpt of the message, so
// the hotel can see WHICH replies work and which don't. Persisted on the
// cached message — survives reloads, and a guest can change their mind.
export default function MessageFeedback({
  message,
  index,
  assistantId,
  language,
}: MessageFeedbackProps) {
  const [rating, setRating] = useState<string | null>(
    message.feedback ?? null
  );
  const t = localization.get(language);

  if (!message.content) return null;

  const vote = (next: "up" | "down") => {
    if (rating === next) return;
    setRating(next);
    message.feedback = next;
    chatCache.updateMessage(assistantId, index, message.content, {
      feedback: next,
    });
    Analytics.track("message_feedback", {
      rating: next,
      message: String(message.content).slice(0, 300),
      message_index: index,
    });
  };

  return (
    <div className={`msg-feedback ${rating ? "voted" : ""}`}>
      <button
        className={`msg-feedback-btn ${rating === "up" ? "active" : ""}`}
        onClick={() => vote("up")}
        aria-label={t.feedback_useful}
        title={t.feedback_useful}
      >
        <ThumbsUp className="icon" />
      </button>
      <button
        className={`msg-feedback-btn down ${
          rating === "down" ? "active" : ""
        }`}
        onClick={() => vote("down")}
        aria-label={t.feedback_not_useful}
        title={t.feedback_not_useful}
      >
        <ThumbsDown className="icon" />
      </button>
    </div>
  );
}
